// ✅ Fuente única de verdad para metas de producción y colores por proceso,
// usada en /stats para que ambas cosas se vean consistentes en todas las
// gráficas.

// Meta de piezas entregadas POR DÍA, por proceso (las que no aparecen aquí
// no tienen meta definida y simplemente no dibujan línea de meta).
const PROCESO_GOALS_DAILY = {
  HOTSTAMPING: 5000,
  TRANSFER: 13000,
  LASER: 5000,
  INKJET: 15000,
};

// Color fijo por proceso (se usa tanto en las barras "Por proceso" como en
// los segmentos apilados de "Quién entrega más").
const PROCESO_COLORS = {
  ULTRASONIDO: "#0d6efd",
  PLASMA: "#20c997",
  HOTSTAMPING: "#fd7e14",
  TRANSFER: "#6f42c1",
  LASER: "#dc3545",
  INKJET: "#ffc107",
  OTRO: "#6c757d",
  SINDATO: "#adb5bd",
};

const DEFAULT_PROCESO_COLOR = "#adb5bd";

// Normaliza el nombre de proceso a una clave estable para buscar meta/color:
// mayúsculas, sin espacios/guiones, y cualquier variante de "OTRO - texto"
// cae en el bucket "OTRO".
export const normalizeProcesoKey = (proceso) => {
  const raw = String(proceso || "").trim().toUpperCase();
  if (!raw) return "SINDATO";
  if (raw.startsWith("OTRO")) return "OTRO";
  return raw.replace(/[^A-Z0-9]/g, "");
};

// Meta diaria (piezas) del proceso, o null si no tiene meta definida.
export const getProcesoDailyGoal = (proceso) =>
  PROCESO_GOALS_DAILY[normalizeProcesoKey(proceso)] ?? null;

export const getProcesoColor = (proceso) =>
  PROCESO_COLORS[normalizeProcesoKey(proceso)] ?? DEFAULT_PROCESO_COLOR;

// Días HÁBILES que representa el periodo, para escalar la meta diaria.
// Domingo no se trabaja, así que no cuenta:
// - semana (L-D) => siempre 6 días hábiles.
// - mes => días reales del mes de `date` menos los domingos que caen en él.
export const getPeriodDays = (period, date) => {
  if (period === "week") return 6;
  if (period === "month") {
    const d = date instanceof Date ? date : new Date(date);
    const totalDays = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
    let working = 0;
    for (let day = 1; day <= totalDays; day++) {
      const isSunday = new Date(d.getFullYear(), d.getMonth(), day).getDay() === 0;
      if (!isSunday) working++;
    }
    return working;
  }
  return 1; // "day"
};

export const getPeriodGoalLabel = (period, periodDays) => {
  if (period === "week" || period === "month") return `Meta (×${periodDays} días hábiles)`;
  return "Meta diaria";
};
